import { Colors } from '@/common/colors/colors';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import Input from '@/common/components/Input';
import PopUp from '@/common/components/PopUp';
import { useTranslationContext } from '@/common/hooks/useTranslationContext';
import React, { useRef } from 'react';
import { ErrorMessage } from './AddressPopup.styles';
import Loading from '@/common/components/Loading';
import { ADDRESS_FORCE_SAVE_VALIDATION_CALLS } from '../constants/addressForceSaveValidationCalls';
import { COUNTRY_ADDRESS_FIELDS } from './constants/countryAddressFields';

const AddressPopup = ({ contact, hook }) => {
	const { translation } = useTranslationContext();
	const {
		handleSubmitAddressForm,
		addressFormInputs,
		handleChangeInputValue,
		validationCalls,
		isSaved,
	} = hook;

	return (
		<PopUp setShow={hook.setIsAddressPopupOpen}>
			{hook.validationMessage && (
				<ErrorMessage>{hook.validationMessage}</ErrorMessage>
			)}
			{hook.isLoading && <Loading />}
			<form
				style={{
					display: 'flex',
					alignItems: 'center',
					flexDirection: 'column',
					gap: '12px',
				}}
			>
				<Input
					margin='6px'
					name={translation.postalCode}
					width={120}
					inputWidth={260}
					value={addressFormInputs.postalCode}
					requiredSign
					placeholder=''
					controlled={true}
					onChange={(e) => handleChangeInputValue('postalCode', e)}
				/>
				<Input
					margin='6px'
					name={translation.city}
					width={120}
					inputWidth={260}
					value={addressFormInputs.city}
					requiredSign
					placeholder=''
					controlled={true}
					onChange={(e) => handleChangeInputValue('city', e)}
				/>
				{COUNTRY_ADDRESS_FIELDS.quarter.includes(contact.country) && (
					<Input
						margin='6px'
						name={translation.quarter}
						width={120}
						inputWidth={260}
						value={addressFormInputs.quarter}
						requiredSign
						placeholder=''
						controlled={true}
						onChange={(e) => handleChangeInputValue('quarter', e)}
					/>
				)}
				<Input
					margin='6px'
					name={translation.street}
					width={120}
					inputWidth={260}
					value={addressFormInputs.street}
					requiredSign
					placeholder=''
					controlled={true}
					onChange={(e) => handleChangeInputValue('street', e)}
				/>
				{COUNTRY_ADDRESS_FIELDS.businessOrComplexName.includes(
					contact.country,
				) && (
					<Input
						margin='6px'
						name={translation.businessOrComplexName}
						width={120}
						inputWidth={260}
						value={addressFormInputs.businessOrComplexName}
						placeholder=''
						controlled={true}
						onChange={(e) => handleChangeInputValue('businessOrComplexName', e)}
					/>
				)}

				{COUNTRY_ADDRESS_FIELDS.streetNumber.includes(contact.country) && (
					<Input
						margin='6px'
						name={translation.streetNumber}
						width={120}
						inputWidth={260}
						value={addressFormInputs.streetNumber}
						placeholder=''
						controlled={true}
						onChange={(e) => handleChangeInputValue('streetNumber', e)}
					/>
				)}
				<Input
					margin='6px'
					name={translation.building}
					width={120}
					inputWidth={260}
					value={addressFormInputs.building}
					placeholder=''
					controlled={true}
					onChange={(e) => handleChangeInputValue('building', e)}
					requiredSign
				/>
				{COUNTRY_ADDRESS_FIELDS.entrance.includes(contact.country) && (
					<Input
						margin='6px'
						name={translation.entrance}
						width={120}
						inputWidth={260}
						value={addressFormInputs.entrance}
						placeholder=''
						controlled={true}
						onChange={(e) => handleChangeInputValue('entrance', e)}
					/>
				)}
				{COUNTRY_ADDRESS_FIELDS.staircase.includes(contact.country) && (
					<Input
						margin='6px'
						name={translation.staircase}
						width={120}
						inputWidth={260}
						value={addressFormInputs.staircase}
						placeholder=''
						controlled={true}
						onChange={(e) => handleChangeInputValue('staircase', e)}
					/>
				)}
				{COUNTRY_ADDRESS_FIELDS.floor.includes(contact.country) && (
					<Input
						margin='6px'
						name={translation.floor}
						width={120}
						inputWidth={260}
						value={addressFormInputs.floor}
						placeholder=''
						controlled={true}
						onChange={(e) => handleChangeInputValue('floor', e)}
					/>
				)}
				<Input
					margin='6px'
					name={translation.apartment}
					width={120}
					inputWidth={260}
					value={addressFormInputs.apartment}
					placeholder=''
					controlled={true}
					onChange={(e) => handleChangeInputValue('apartment', e)}
				/>
				<Input
					margin='6px'
					name={translation.phone_number_for_courier}
					width={120}
					inputWidth={260}
					value={addressFormInputs.phoneForCourier}
					placeholder=''
					controlled={true}
					onChange={(e) => handleChangeInputValue('phoneForCourier', e)}
				/>
				<Input
					margin='6px'
					name={translation.courierInfo}
					width={120}
					inputWidth={260}
					value={addressFormInputs.additionalInfo}
					placeholder=''
					controlled={true}
					onChange={(e) => handleChangeInputValue('additionalInfo', e)}
				/>
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
						gap: '30px',
						width: '100%',
					}}
				>
					{!hook.isLoading &&
						(isSaved ? (
							<SubmitButton
								color={Colors.lightGreen}
								text={translation.saved}
								onClick={(e) => e.preventDefault()}
							/>
						) : validationCalls >= ADDRESS_FORCE_SAVE_VALIDATION_CALLS ? (
							<SubmitButton
								color={Colors.red2}
								text={`!!! ${translation.save}`}
								onClick={(e) => handleSubmitAddressForm(e, contact._id, true)}
							/>
						) : (
							<SubmitButton
								color={Colors.blue}
								text={translation.save}
								onClick={(e) => handleSubmitAddressForm(e, contact._id, false)}
							/>
						))}
				</div>
			</form>
		</PopUp>
	);
};

export default AddressPopup;
